export const nameRe = [
  {
    re: new RegExp(
      '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?',
    ),
    text: 'no_url',
    not: true,
  },
  {
    re: new RegExp('^([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?'),
    text: 'no_url',
    not: true,
  },
  { re: /[a-zA-Z]{3,}/, text: 'min_3' },
];

export const emailRe = /^[A-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Z0-9.-]+$/i;

export const passwordRe = [
  { re: /[!@#$%^&*()_+=[\]{}|;:'",<.>/?-]{1}/, text: '1_symbol' },
  { re: /[a-z]{1}/, text: '1_lowercase' },
  { re: /[A-Z]{1}/, text: '1_uppercase' },
  { re: /[0-9]{1}/, text: '1_digit' },
  { re: /^.{8,32}$/, text: '8_32_characters' },
];

export function validateName(name: string) {
  const errors = [];

  for (const re of nameRe) {
    if (re.not) {
      if (name.match(re.re)) errors.push(`error_${re.text}`);
    } else if (!name.match(re.re)) errors.push(`error_${re.text}`);
  }
  if (errors.length > 0) {
    return errors[0];
  }
  return true;
}

export function validateEmail(email: string) {
  const errors = [];

  if (!email.match(emailRe)) errors.push('error_email_format');

  if (errors.length > 0) {
    return errors[0];
  }
  return true;
}

export function validatePassword(password: string) {
  const errors = [];

  for (const re of passwordRe) {
    if (!password.match(re.re)) errors.push(`error_${re.text}`);
  }

  if (errors.length > 0) {
    return errors[0];
  }
  return true;
}

export function validateAccountInfo(name: string, email: string) {
  const nameError = validateName(name);
  if (nameError !== true) return nameError;

  const emailError = validateEmail(email);
  if (emailError !== true) return emailError;

  return true;
}
